import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import Chip from 'material-ui/Chip';
import { stringHumanize } from '../util'
import AlertWarning from 'material-ui/svg-icons/alert/warning';
import ActionDoneIcon from 'material-ui/svg-icons/action/done';
import ContentClearIcon from 'material-ui/svg-icons/content/clear';
import Avatar from 'material-ui/Avatar';

const styles = {
	pending: {
		chip: {
			backgroundColor: '#ffc107',
			labelColor: '#fff'
		},
		avatar: {
			backgroundColor: '#ffa000',
			color: '#fff',
			icon: <AlertWarning />
		}
	},
	complied: {
		chip: {
			backgroundColor: '#4caf50',
			labelColor: '#fff',
		},
		avatar: {
			backgroundColor: '#388e3c',
			color: '#fff',
			icon: <ActionDoneIcon />
		}
	},
	compliance_rejected: {
		chip: {
			backgroundColor: '#C62828',
			labelColor: '#fff',
		},
		avatar: {
			backgroundColor: '#B71C1C',
			color: '#fff',
			icon: <ContentClearIcon />
		}
	},
}

const DisabledStatusChip = ({
    input: { value },
    label,
    resource,
    source,
    elStyle,
}) => (
	<div>
	    <TextField
			floatingLabelText={label}
	        value={value}
	        style={{ ...elStyle, opacity: 0, height: 0, overflow: "hidden" }}
	        disabled
	    />
		<Chip {...( styles[value] || styles['complied'] ).chip}>
			<Avatar {...( styles[value] || styles['complied'] ).avatar} />
			{stringHumanize(value)}
		</Chip>
	</div>
)

DisabledStatusChip.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    elStyle: PropTypes.object,
    input: PropTypes.object,
    addField: PropTypes.bool.isRequired,
};

DisabledStatusChip.defaultProps = {
    addField: true,
};

export default DisabledStatusChip;



// WEBPACK FOOTER //
// ./src/inputs/DisabledStatusChip.js